import React, { useEffect, useState } from "react"
import { Link, router, usePage } from "@inertiajs/react"
import organizeMenusIntoHierarchy from "@/utils/organizeMenusIntoHierarchy"
import MenuItem from "@/Admin/Components/Header/MenuItem"
import { useSelector } from "react-redux"
import SideHeader from "./SideHeader"
import Button from "../Button"
import LanguageDropdown from "./LanguageDropdown"
import gravatarUrl from "gravatar-url"
import translate from "@/utils/translate"
import useConfirmation from '@/Admin/Components/ActionConfirmation/useConfirmation';
import ConfirmationModal from '@/Admin/Components/ActionConfirmation/ConfirmationModal';

export default function Header3() {
    const { cart_slug } = usePage().props
    const { carts } = useSelector((state) => state.carts)
    const { currentLang, pageInfo } = useSelector((state) => state.pages)
    const { lang, auth } = usePage().props
    const currentLangPageInfo = pageInfo[currentLang]
    const customize = useSelector((state) => state.customize)
    const [sideHeaderToggle, setSideHeaderToggle] = useState(false)
    const [mobileToggle, setMobileToggle] = useState(false)
    const [hamburgerToggle, setHamburgerToggle] = useState(false)
    const [isSticky, setIsSticky] = useState()
    const [profileDropdownOpen, setProfileDropdownOpen] = useState(false)
    const currentLanguage = currentLang ?? lang.default_lang
    const mainMenus = localStorage.getItem("main_menu") ? JSON.parse(localStorage.getItem("main_menu")) : []
    const menus = mainMenus ? organizeMenusIntoHierarchy(mainMenus[currentLanguage]) : []

    const confirmLogout = useConfirmation();

    const cartItemCount = carts?.reduce((total, item) => total + (item.quantity ?? 1), 0) ?? 0

    const handleProfileDropdownToggle = () => setProfileDropdownOpen(!profileDropdownOpen)

    // handle logout
    const handleLogout = () => {
        confirmLogout.showConfirmation({
            title: `${translate("Are you sure")}`,
            message: `${translate("logout_session")}`,
            confirmText: `${translate("log_out")}!`,
            cancelText: translate("Cancel"),
            onConfirm: () => {
                router.post(route("logout"))
            },
            onCancel: () => {},
            onClose: () => {},
        });
    }

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                setIsSticky(true)
            } else {
                setIsSticky(false)
            }
        })
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(".cs_dropdown_wrap")) {
                setProfileDropdownOpen(false)
            }
        }

        if (profileDropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside)
        } else {
            document.removeEventListener("mousedown", handleClickOutside)
        }

        return () => document.removeEventListener("mousedown", handleClickOutside)
    }, [profileDropdownOpen])

    return (
        <>
            <header id="top" className={`cs_site_header cs_style_2 cs_color_1 cs_sticky_header${isSticky ? " cs_sticky_active" : ""}`}>
                <div className="cs_main_header">
                    <div className="container">
                        <div className="cs_main_header_in">
                            <div className="cs_main_header_left">
                                <div className="cs_toolbox">
                                    <button className="cs_hamburger_btn cs_hamburger_menu_btn" onClick={() => setHamburgerToggle(!hamburgerToggle)}>
                                        <i className="fa-regular fa-bars-staggered fs-4"></i>
                                    </button>
                                    {Object.entries(lang.languages).length > 1 && <LanguageDropdown />}
                                    {auth?.is_loggedIn ? (
                                        <div className="cs_dropdown_wrap">
                                            <div
                                                onClick={handleProfileDropdownToggle}
                                                className={`cs_header_user_btn ${profileDropdownOpen ? "active" : ""}`}
                                            >
                                                <i className="fa-light fa-circle-user" style={{ fontSize: '20px' }}></i>
                                            </div>
                                            {profileDropdownOpen && (
                                                <div className="cs_header_user_dropdown">
                                                    <div className="cs_header_user_info">
                                                        <img src={gravatarUrl(auth?.user?.email) ?? ""} alt="" />
                                                        <h4 className="">{auth?.user?.name}</h4>
                                                        <p className="">{auth?.user?.email}</p>
                                                    </div>
                                                    <ul className="cs_header_user_list cs_mp0">
                                                        <li>
                                                            <Link href={route("user.dashboard")}>{translate("Dashboard")}</Link>
                                                        </li>
                                                        <li>
                                                            <Link href={route("user.orders")}>{translate("My Orders")}</Link>
                                                        </li>
                                                        <li>
                                                            <Link href={route("user.profile.edit")}>{translate("Profile")}</Link>
                                                        </li>
                                                        <li>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                                                                {translate("log_out")}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="cs_header_user_btn active d-flex">
                                            <Link href={route("login.create")}>{translate("Login")}</Link>
                                        </div>
                                    )}
                                    {currentLangPageInfo?.is_show_shopping_cart && (
                                        <Link href={route("pages.show", { slug: cart_slug })} className="cart-counter text-white">
                                            <i className="fa-sharp fa-light fa-cart-arrow-down fs-4"></i>
                                            {cartItemCount === 0 ? "" : <span>{cartItemCount}</span>}
                                        </Link>
                                    )}
                                </div>
                            </div>
                            <div className="cs_main_header_center">
                                <Link className="cs_site_branding" to="/" href="/">
                                    <img src={customize?.general?.site_logo_light ?? ""} alt={customize?.general?.site_name ?? ""} />
                                </Link>
                            </div>
                            <div className="cs_main_header_right">
                                <Button
                                    href={currentLangPageInfo?.header_action_button_url ?? "#"}
                                    btnText={currentLangPageInfo?.header_action_button_text ?? ""}
                                    btnClass="cs_btn cs_style_1 cs_type_2 cs_primary_bg cs_white_color"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className={`cs_hamburger_overlay${hamburgerToggle ? " active" : ""}`} onClick={() => setHamburgerToggle(!hamburgerToggle)} />
            <div className={`cs_hamburger_header cs_ternary_color cs_start_left${hamburgerToggle ? " active" : ""}`}>
                <button className="cs_close_hamburger" onClick={() => setHamburgerToggle(!hamburgerToggle)}>
                    <i className="fa-light fa-xmark" style={{ fontSize: '24px', color: 'white' }}></i>
                </button>
                <div className="cs_hamburger_brand">
                    <Link className="cs_site_branding" to="/" href="/">
                        <img src={customize?.general?.site_logo_light ?? ""} alt={customize?.general?.site_name ?? ""} />
                    </Link>
                </div>
                <nav className="cs_hamburger_menu cs_white_color">
                    <ul className="cs_nav_list cs_primary_font cs_light">
                        {menus?.map((menuItem) => (
                            <MenuItem setMobileToggle={setMobileToggle} key={menuItem.id} item={menuItem} />
                        ))}
                    </ul>
                </nav>
                <div className="cs_hamburger_footer">
                    {customize?.contact?.contact_phone_number && (
                        <h3>
                            <a href={`tel:${customize?.contact?.contact_phone_number}`}>{customize?.contact?.contact_phone_number}</a>
                        </h3>
                    )}
                    {customize?.contact?.contact_email && (
                        <p className="mb-0">
                            <a href={`mailto:${customize?.contact?.contact_email}`}>{customize?.contact?.contact_email}</a>
                        </p>
                    )}
                </div>
            </div>
            <SideHeader sideHeaderToggle={sideHeaderToggle} setSideHeaderToggle={setSideHeaderToggle} customize={customize} />

            <ConfirmationModal
                isOpen={confirmLogout.isOpen}
                title={confirmLogout.title}
                message={confirmLogout.message}
                confirmText={confirmLogout.confirmText}
                cancelText={confirmLogout.cancelText}
                onConfirm={confirmLogout.handleConfirm}
                onCancel={confirmLogout.handleCancel}
                onClose={confirmLogout.handleClose}
            />
        </>
    )
}